import React, { useState } from "react";

export default function LoginPage({ onLogin }) {
  const [password, setPassword] = useState("");

  const handleLogin = () => {
    if (password === "admin123") {
      onLogin();
    } else {
      alert("Wrong password");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <h1 className="text-2xl mb-4">Admin Login</h1>
      <input
        type="password"
        placeholder="Enter password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="p-2 border rounded mb-2"
      />
      <button onClick={handleLogin} className="bg-blue-500 text-white px-4 py-2 rounded">
        Login
      </button>
    </div>
  );
}
